import { createFileRoute } from '@tanstack/react-router'
import { ComplianceTab } from '@/features/incidents/reports/compliance/compliance-tab'

export const Route = createFileRoute(
  '/_authenticated/_organization/incidents/reports/compliance'
)({
  component: ComplianceTab,
})

